<template>
    <page-layout>
        <ig-connection-faq context="brief" />

        <template #footer>
            <step-footer
                :step="step"
                :is-next-disabled="true"
                :use-exit-modal="false"
                @go-previous-step="handlePreviousStep"
            />
        </template>
    </page-layout>
</template>

<script>
    import PageLayout from '../../layouts/PageLayout.vue';
    import StepFooter from './partials/StepFooter.vue';
    import IgConnectionFaq from '../networks/partials/IgConnectionFaq.vue';
    import { INSTAGRAM_ID } from '../../../constants/networks';

    export default {
        name: 'ActivationBriefNetworksFaqView',
        components: {
            IgConnectionFaq,
            StepFooter,
            PageLayout
        },
        props: {
            brief: {
                type: Object,
                default: null
            },
            step: {
                type: Object,
                default: null
            }
        },
        methods: {
            handlePreviousStep() {
                this.$router.push({
                    name: 'v2.activation.brief.networks.network',

                    query: {
                        networkId: INSTAGRAM_ID
                    }
                });
            }
        }
    };
</script>
